import { StyledError } from './styles';

interface Props {
  children: React.ReactNode;
  id?: string;
}

export const AlluraErrorMessage = ({ children, id }: Props) => {
  return (
    <StyledError variant="body2" id={id}>
      {children}
    </StyledError>
  );
};
